import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import { Container, Navbar, Nav, Col } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import { Howl } from "howler";

const Header = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [notification, setNotification] = useState(null);
  const { id } = useParams();
  let loginUserId = null;  // Initialize loginUserId as null

  // Retrieve the session data from sessionStorage
  const session = JSON.parse(sessionStorage.getItem("user"));

  // Check if session is available
  if (!session) {
    // If session is not available, navigate to the login page
    navigate("/");
  } else {
    // If session exists, get the UserId and assign it to loginUserId
    loginUserId = session.UserId;
  }

  // Log the loginUserId to the console
  console.log(loginUserId);

  // Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyACYHTB68p1CBv1pW0MJSM2liB76uWBSOw",
    authDomain: "webdoc-896a8.firebaseapp.com",
    databaseURL: "https://webdoc-896a8.firebaseio.com",
    projectId: "webdoc-896a8",
    storageBucket: "webdoc-896a8.appspot.com",
    messagingSenderId: "642677587502",
    appId: "1:642677587502:web:b44f84172056b7971a69bf",
    measurementId: "G-JTMSYGQBYX",
  };

  const app = initializeApp(firebaseConfig);
  const database = getDatabase(app);

  const handleLogout = () => {
    sessionStorage.removeItem("user"); // Clear session data
    logout();
    navigate("/");
  };

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user && user.Email) {
      const doctorEmail = formatEmail(user.Email);
      setIsLoggedIn(true);
      checkIsCallingForDoctor(doctorEmail, user.Email);
    }
  }, []);

  const formatEmail = (email) => {
    return email.replace(/\./g, ""); // Remove dots from the email
  };

  // Create a new Howl instance
  const sound = new Howl({
    src: ["/ringtone.mp3"], // Update with your audio file
    loop: true,
    volume: 1.0,
  });

  const playTune = () => {
    sound.play();
  };

  const stopTune = () => {
    sound.stop();
  };

  const checkIsCallingForDoctor = (doctorName, orginalEmail) => {
    onValue(ref(database, `DoctorCall/${doctorName}`), (snapshot) => {
      const doctorData = snapshot.val();
      if (doctorData && doctorData.IsCalling === "true") {
        playTune();

        setNotification({
          callType: doctorData.CallType,
          senderEmail: doctorData.SenderEmail,
          onJoin: () => {
            stopTune(); // Stop the sound when joining
            navigate(
              `/incoming/?channel=${orginalEmail}&doctorId=${loginUserId}&senderEmail=${doctorData.SenderEmail}`
            );
            setNotification(null); // Clear notification after joining
          },
        });

        // Auto-dismiss after 30 seconds and stop sound
        setTimeout(() => {
          setNotification(null);
          stopTune();
        }, 30000);
      }
    });
  };

  const location = useLocation(); // Get current location

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Navbar
        expand="lg"
        className="bg-body-tertiary"
        style={{ borderRadius: "12px" }}
      >
        <Container fluid>

          <Navbar.Brand href={`/Dashboard/${loginUserId}`} className="me-5">
            <img src="/logob.png" style={{ width: '100px' }} alt="logo" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" className="bg_primary px-2"
            style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255,255,255)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E")`, backgroundSize: '50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
          />
          <Navbar.Collapse id="basic-navbar-nav">

            <Col xs="9" sm="8" md="10" lg="11"  >
              <Nav className="me-auto">
                <Nav.Link
                  className={`me-2 custom_nav ${isActive(`/Dashboard/${loginUserId}`) ? 'active' : ''}`}
                  href={`/Dashboard/${loginUserId}`}
                >
                  Dashboard
                </Nav.Link>
                <Nav.Link
                  className={`me-2 custom_nav ${isActive(`/DoctorProfile/${loginUserId}`) ? 'active' : ''}`}
                  href={`/DoctorProfile/${loginUserId}`}
                >
                  Profile
                </Nav.Link>

                <Nav.Link
                  className={`me-2 custom_nav ${isActive(`/DoctorSchedule/${loginUserId}`) ? 'active' : ''}`}
                  href={`/DoctorSchedule/${loginUserId}`}
                >
                  Schedule
                </Nav.Link>

                <Nav.Link
                  className={`me-2 custom_nav ${isActive(`/DoctorAppointment/${loginUserId}`) ? 'active' : ''}`}
                  href={`/DoctorAppointment/${loginUserId}`}
                >
                  Appointments
                </Nav.Link>
                {/* <Nav.Link
                  className={`me-2 custom_nav ${isActive(`/FinanceDetail/${loginUserId}`) ? 'active' : ''}`}
                  href={`/FinanceDetail/${loginUserId}`}
                >
                  Finance Detail
                </Nav.Link> */}
              </Nav>
            </Col>
            <Col xs="3" sm="4" md="2" lg="1">
              <Nav className="justify-content-end">

                <Nav.Link className="custom_nav" onClick={handleLogout}>Log out</Nav.Link>
              </Nav>
            </Col>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {notification && (
        <div className="notification bg_light">
          <div>
            <strong className="text_primary">{notification.callType}</strong>
            {/* {notification.senderEmail}. */}
          </div>
          <button className="btn_primary" onClick={notification.onJoin}>Join Now</button>
        </div>
      )}
    </>
  );
};

export default Header;
